import React from 'react';

interface TutorialsIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const TutorialsIcon: React.FC<TutorialsIconProps> = ({
  className = '',
  color = 'white',
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M18.1 17.75H5.89999C3.57999 17.75 2.25 16.42 2.25 14.1V2C2.25 1.59 2.59 1.25 3 1.25H21C21.41 1.25 21.75 1.59 21.75 2V14.1C21.75 16.42 20.42 17.75 18.1 17.75ZM3.75 2.75V14.1C3.75 15.59 4.40999 16.25 5.89999 16.25H18.09C19.58 16.25 20.24 15.59 20.24 14.1V2.75H3.75Z"
        fill="currentColor"
      />
      <path
        d="M22 2.75H2C1.59 2.75 1.25 2.41 1.25 2C1.25 1.59 1.59 1.25 2 1.25H22C22.41 1.25 22.75 1.59 22.75 2C22.75 2.41 22.41 2.75 22 2.75Z"
        fill="currentColor"
      />
      <path
        d="M8.00027 22.75C7.72027 22.75 7.46025 22.6 7.33025 22.34C7.14025 21.97 7.29028 21.52 7.67028 21.33L11.2503 19.54V17C11.2503 16.59 11.5903 16.25 12.0003 16.25C12.4103 16.25 12.7503 16.59 12.7503 17V20C12.7503 20.28 12.5903 20.54 12.3303 20.67L8.33025 22.67C8.23025 22.72 8.11027 22.75 8.00027 22.75Z"
        fill="currentColor"
      />
      <path
        d="M16 22.75C15.8899 22.75 15.77 22.72 15.67 22.67L11.67 20.67C11.3 20.48 11.1499 20.03 11.3299 19.66C11.5199 19.29 11.9699 19.14 12.3399 19.32L16.3399 21.32C16.7099 21.51 16.8599 21.96 16.6799 22.33C16.5399 22.6 16.27 22.75 16 22.75Z"
        fill="currentColor"
      />
      <path
        d="M7.49993 11.75C7.28993 11.75 7.06994 11.66 6.91994 11.48C6.64994 11.16 6.69991 10.69 7.01992 10.42L10.1699 7.79C10.4599 7.55 10.8299 7.45 11.1799 7.51C11.5399 7.57 11.8499 7.78997 12.0399 8.10997L13.0899 9.85997L16.0199 7.42C16.3399 7.16 16.8099 7.19998 17.0799 7.51998C17.3499 7.83998 17.2999 8.30998 16.9799 8.57998L13.8299 11.21C13.5399 11.45 13.1699 11.55 12.8199 11.49C12.4599 11.43 12.1499 11.21 11.9599 10.89L10.9099 9.14L7.97994 11.58C7.83994 11.69 7.66993 11.75 7.49993 11.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TutorialsIcon;
